import discover from "./discover";
import header from "./header";
import banner from "./banner";
import animation from "./animation";
import define from "./define";
import vm from "./vm";
// import app_promo from "./app_promo";
// import footer from "./footer";
import meta_data from "./meta_data";
import footer from "./footer";
import common from "./common";

const data = {
  'Home.message': "It's a beautiful day outside.",
  'home.beauty_advisor': 'Beauty Advisor',
  'home.virtual_mirror': 'Virtual Mirror',
  'home.lens_find': 'Find the Best Lens for me.',
  'home.lens_continue': 'Tap to continue',
  'home.quiz_find': 'Find my persona',
  'home.logout': 'Logout',
  'home.let_us_find': 'Let us find the',
  'home.look_for_you': 'look for you',
  'home.try_a_lens': 'Try a lens',
  'home.color': 'color',
  'without_quiz.lens_color': 'Try a lens color',
  "without_quiz.access_cam": "Define Ingin Mengakses Kamera",
  "without_quiz.access_cam_sub_text": "Coba Langsung",
  'without_image.img_confirm': 'Are you sure you want to use this image?',
  'without_image.Allow': "Tidak Mengizinkan",
  'without_image.OK': 'Oke',
  'dba.find_look': 'Let us find the look for you',
  'dba.about_urself': 'PILIH SESUAI DENGAN DIRI ANDA',
  'dba.trydba': 'Try the DBA App',
  'dba.type': 'TIPE ANDA',
  'dba.next': 'Selanjutnya',
  'dba.submit': 'COBA WARNA YANG DIPILIH',
  'dba.Currently wearing:': 'Currently wearing:',
  "quiz.skin_color" : "Apa warna kulit kamu?",
  "quiz.hair_Color" : "Apa warna rambut kamu?",
  'quiz.help': 'Jawab semua pertanyaan dan tekan tombol selanjutnya',
  'menu.home': 'Home',
  'menu.bye': 'Bye',
  'menu.share': 'Share',
  'menu.save': 'Save',
  'menu.trail': 'Free trial',
  'menu.find': 'Find Doctor',
  'menu.product': 'Product Info',
  'lens.bright': 'Radiant Bright™',
  'lens.shine': 'Natural Shine™',
  'lens.charm': 'Radiant Charm™',
  'lens.chic': 'Radiant Chic™',
  'lens.sweet': 'Radiant Sweet™',
  'lens.vivid': 'Vivid Style',
  'lens.accent': 'Accent Style',
  'footer.care': 'About Lens Care',
  'footer.products': 'About Products',
  'footer.legal': 'Legal Notice',
  'footer.acuvue': 'Tentang ACUVUE<sup>®</sup> DEFINE<sup>®️</sup>',
  'footer.contact': 'HUBUNGI KAMI',
  'footer.privacy': 'Privacy Policy',
  'footer.label': 'Tentang',
  'footer.makeup': 'Makeup Tutorial',
  'login.email': 'E-mail',
  'login.password': 'Password',
  'login.submit': 'Submit',
  'nav.welcome_guest': 'Welcome Guest',
  'vm.currently_wearing': 'Currently Wearing',
  'vm.rec_variant': 'Recommended Variant',
  'product_info.about': 'Tentang Lensa Kontak Kami',
  'lens.now': 'Now',
  'tabs.classic_lenses': 'Define Classic',
  'tabs.fresh_lenses': 'Define Fresh',
  'tabs.looks': 'Looks',
  'tabs.makeup': 'Tampilan Makeup',
  'tabs.insertion': 'CARA MEMASANG',
  'tabs.removal': 'CARA MELEPAS',
  'tooltip.home': 'Home',
  'tooltip.ba': 'Beauty Advisor',
  'tooltip.care': 'Lens Care',
  'tooltip.more': 'More Options',
  'tooltip.buy': 'Buy',
  'tooltip.share': 'Share',
  'tooltip.trial': 'Free Trial',
  'tooltip.ecp': 'Find ECP',
  'tooltip.logout': 'Logout',
  'tooltip.vm': 'Virtual Try On',
  'modal.share': 'Share',
  'modal.buy': 'Buy',
  'modal.free_trial': 'Free Trial',
  'modal.shop_now': 'Shop Now',
  'modal.go': 'Go',
  'looks.downloadPdf': 'Download Tutorial',
  'guides.how_to_put_on_lens': 'CARA MENGGUNAKAN LENSA KONTAK DALAM 4 LANGKAH MUDAH',
  'guides.how_to_remove_lens': 'CARA MELEPAS LENSA KONTAK DALAM 4 LANGKAH MUDAH',
  'looks.you_have_selected': 'You have selected: ',
  'tutorials.or': 'OR',
  'tutorials.scan': 'Scan QR code to download',
  'tutorials.product_unavailable':
  'This product is currently unavailable in this market.',
  'tutorials.look': 'Look ',
  'products.disclaimer_header': 'Referensi/Disklaimer',
  'tutorials.purchase': 'Buy online',
  'tutorials.lens': 'Lens',
  'looks.best_suited': 'look is best suited with',
  'looks.product_unavailable': 'Not Available',
  'looks.you_have_chosen': 'KAMU TELAH MEMILIH:',
  'looks.with_lens': 'With Lens:',
  'looks.with_looks': 'With Looks:',
  'modal.buy_button': 'Shop Now',
  'permissions.allow_look_removal': 'This action would remove applied look',
  'permissions.allow_makeup_removal': 'This action would remove applied makeup',
  'permissions.allow_look_removal_sub_text': 'Do you want to proceed?',
  'tabs.pls_select_look': 'Please select a look',
  'tabs.pls_select_lens': 'Please select a lens',
  'tabs.pls_select_makeup_category': 'Please select a makeup category',
  'button.value_try_the': 'Coba',
  'button.heading_try_the': 'Lensa Kontak',
  'button.value_find_your': 'Temukan',
  'button.heading_find_your': 'Personamu',
  'button.value_price': 'Download Myacuvue',
  'button.heading_price': 'MyAcuvue',
  'products.external_buy': 'Shop Now',
  'product.browser-alert' : 'Dapatkan pengalaman terbaik dengan pengaturan cahaya yang terang dan alami.<br/>Fitur ini tidak didukung di Internet Explorer'
};

const home_references = {
  "home_references": "<p> **Teknologi LACREON® adalah nama merek Johnson & Johnson Vision Care, Inc. untuk teknologi kepemilikan yang secara permanen menanamkan bahan pengikat air seperti dengan yang ditemukan pada air mata alami, ke dalam bahan etaﬁlcon A. </p> <p>Informasi penting untuk pengguna lensa kontak: Merek Lensa Kontak ACUVUE® hanya tersedia dengan resep dokter untuk koreksi penglihatan. Dokter mata akan menentukan apakah lensa kontak cocok untuk Anda. Meskipun jarang terjadi, masalah mata serius dapat berkembang saat memakai lensa kontak. Untuk membantu menghindari masalah ini, ikuti jadwal pemakaian dan penggantian serta instruksi perawatan lensa yang diberikan oleh dokter mata Anda. Jangan memakai lensa kontak jika Anda mengalami infeksi mata, atau mengalami ketidaknyamanan mata, robekan berlebihan, perubahan penglihatan, kemerahan, atau masalah mata lainnya. Jika salah satu dari kondisi ini terjadi, segera hubungi dokter mata Anda. Untuk informasi lebih lanjut tentang penggunaan, perawatan, dan keamanan yang tepat, bicarakan dengan Dokter Mata Anda atau lihat Panduan Instruksi Pasien ACUVUE®.</p>"
}

export default {
  ...header,
  // ...app_promo,
  ...data,
  ...home_references,
  ...banner,
  ...animation,
  ...discover,
  ...define,
  ...vm,
  // ...footer,
  ...meta_data,
  ...footer,
  ...common,
};


